import { useConversations } from '@/lib/hooks/useConversations';
import { ScrollArea } from '../ui/scroll-area';
import { Alert, AlertDescription } from '../ui/alert';
import ConversationItem from './ConversationItem';
import { Loader2, MessageSquare, AlertCircle } from 'lucide-react';

function ConversationList() {
  const { data: conversations, isLoading, isError, error } = useConversations();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (isError) {
    return (
      <Alert variant="danger">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>{error.message}</AlertDescription>
      </Alert>
    );
  }

  if (!conversations || conversations.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center text-muted-foreground">
        <MessageSquare className="h-8 w-8 mb-2 text-gray-400" />
        <p className="text-sm">Nessuna conversazione</p>
      </div>
    );
  }

  // Sort conversations by updatedAt timestamp (most recent first)
  const sortedConversations = [...conversations].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );

  return (
    <ScrollArea className="h-full">
      <div className="space-y-1">
        {sortedConversations.map((conversation) => (
          <ConversationItem key={conversation.id} conversation={conversation} />
        ))}
      </div>
    </ScrollArea>
  );
}

export default ConversationList;
